(function ($) {
  Drupal.behaviors.pc_em_formatter = {
    attach: function (context, settings) {
      $(window).on('load', function () {
        // Handle linking to specific sections
        function getParameterByName(name, url) {
          if (!url) {
            url = window.location.href;
          }
          name = name.replace(/[\[\]]/g, '\\$&');
          var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);

          if (!results) {
            return null;
          }
          if (!results[2]) {
            return '';
          }

          return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

        // Handle links...?mod[num]=boutique_mod[num]
        function scrollToLinkMod(linkNo) {
          if (getParameterByName('mod' + linkNo) === 'boutique_mod' + linkNo) {
            $('html, body')
              .delay(500)
              .animate(
                {
                  scrollTop:
                    $(
                      '#pcem_look_' +
                        linkNo +
                        ' .pcem_layout_1, #pcem_look_' +
                        linkNo +
                        ' .pcem_layout_2'
                    ).offset().top - 100
                },
                1500,
                'easeInOutQuad'
              );
          }
        }

        for (i = 1; i <= 4; i++) {
          scrollToLinkMod(i);
        }

        // Animate the play button
        $(
          '#pc_em_mod1_play, .pc_em_mod1_hero_txt1, .pc_em_mod1_hero_txt2, .pc_em_mod1_hero_txt3, .pc_em_mod1_hero_txt41, .pc_em_mod1_hero_txt42'
        )
          .delay(350)
          .animate(
            {
              opacity: '1'
            },
            150,
            'easeInOutQuad'
          );
      });

      $('.pc_em_formatter', context).once('pc_em_formatter', function () {
        /** SETUP **/
        // Apply classes
        var isTouch = false;
        var isFF = false;
        var isIE = false;
        var isMobile = false;

        function makeBoutiqueChecks() {
          // Check for Windows.
          if (navigator.platform == 'Win32') {
            $('body').addClass('isWin');
          }

          // Check for Safari.
          if (
            navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1
          ) {
            $('body').addClass('isSafari');
          }

          // Check for Firefox.
          if (navigator.userAgent.search('Firefox') >= 0) {
            $('body').addClass('isFF');
            isFF = true;
          }

          // Check for IE.
          if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
            isIE = true;
          }
          if (isIE) {
            if ($('body').hasClass('isTouch')) {
              $('body').removeClass('isTouch');
            }
          }

          // Check for mobile device
          if (
            /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
          ) {
            isMobile = true;
            $('body').addClass('isMobile');
          }

          // Check for iPad.
          if (navigator.userAgent.match(/iPad/i) != null) {
            isTouch = true;
            $('body').addClass('isTouch');
          }
        }
        makeBoutiqueChecks();

        /** ** SCROLLMAGIC FUNCTIONALITY ****/
        // Init scrollMagic Controller Class
        var controller = new ScrollMagic.Controller();

        /** MODULE 2 **/
        // Reset elements
        function resetMod2() {
          $('.pc_em_mod_headers').css({
            opacity: '0',
            'padding-top': '5%'
          });
          $('.olapic-widget').css({
            opacity: '0',
            'margin-top': '5%'
          });
          $(
            '.pcem_layout_1 .pc_em_lipsticks_img .pc_em_lipsticks_img_src, .pcem_layout_1 .pc_em_swatch_img .pc_em_swatch_img_src, .pcem_layout_1 .pc_em_model_img .pc_em_model_img_src'
          ).css({
            opacity: '0'
          });
          $(
            '.pcem_layout_2 .pc_em_lipsticks_img .pc_em_lipsticks_img_src, .pcem_layout_2 .pc_em_swatch_img .pc_em_swatch_img_src, .pcem_layout_2 .pc_em_model_img .pc_em_model_img_src'
          ).css({
            opacity: '0'
          });
          $(
            '.pcem_layout_3 .pc_em_lipsticks_img .pc_em_lipsticks_img_src, .pcem_layout_3 .pc_em_swatch_img .pc_em_swatch_img_src, .pcem_layout_3 .pc_em_model_img .pc_em_model_img_src'
          ).css({
            opacity: '0'
          });
          $(
            '.pcem_layout_1 .pc_em_details_wrapper, .pcem_layout_2 .pc_em_details_wrapper, .pcem_layout_3 .pc_em_details_wrapper'
          ).css({
            opacity: '0'
          });
        }
        resetMod2();

        // Handle single play-through
        var headerSceneFirstRun = true;

        // Animation
        function headerScene() {
          if (headerSceneFirstRun) {
            $('.pc_em_mod_headers').animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              600,
              'easeOutQuad',
              function () {
                headerSceneFirstRun = false;
              }
            );
          } else {
            return;
          }
        }

        // Init scrollMagic Scene Class
        var headerSceneTimeline = new ScrollMagic.Scene({
          triggerElement: '.pc_em_mod_headers',
          offset: -150
        })
          .on('start', function () {
            headerScene();
          })
          .addTo(controller);
        // Handle single play-through
        var amt = '-=10%';
        var lookOneFirstRun = true;

        // Animation
        function lookOneScene() {
          if (lookOneFirstRun) {
            $('#pcem_look_1')
              .find(
                '.pcem_layout_1 .pc_em_model_img .pc_em_model_img_src1, .pcem_layout_2 .pc_em_model_img .pc_em_model_img_src1'
              )
              .delay(350)
              .animate(
                {
                  opacity: 1
                },
                600,
                'easeInOutQuad'
              );
            $('#pcem_look_1')
              .find(
                '.pcem_layout_1 .pc_em_swatch_img .pc_em_swatch_img_src.back:eq(0), .pcem_layout_2 .pc_em_swatch_img .pc_em_swatch_img_src.back:eq(0)'
              )
              .delay(400)
              .animate(
                {
                  opacity: 1
                },
                600,
                'easeInOutQuad'
              );
            $('#pcem_look_1')
              .find(
                '.pcem_layout_1 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0), .pcem_layout_2 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0)'
              )
              .delay(450)
              .animate(
                {
                  opacity: 1
                },
                560,
                'easeInOutQuad'
              );
            $('#pcem_look_1')
              .find('.pcem_layout_1 .pc_em_details_wrapper, .pcem_layout_2 .pc_em_details_wrapper')
              .delay(600)
              .animate(
                {
                  opacity: 1
                },
                800,
                'easeInOutQuad',
                function () {
                  lookOneFirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        // Init scrollMagic Scene Class
        var lookOneTimeline = new ScrollMagic.Scene({
          triggerElement: '#pcem_look_1 .pcem_layout_1, #pcem_look_1 .pcem_layout_2',
          offset: -100
        })
          .on('start', function () {
            lookOneScene();
          })
          .addTo(controller);
        // Handle single play-through
        var lookTwoFirstRun = true;

        // Animation
        function lookTwoScene() {
          if (lookTwoFirstRun) {
            //            if (isTouch) {
            //             $('.pcem_look_glow:eq(1)').addClass('scaleInTouch');
            //            } else {
            //            $('.pcem_look_glow:eq(1)').addClass('scaleIn');
            //          }
            $('#pcem_look_2')
              .find(
                '.pcem_layout_1 .pc_em_model_img .pc_em_model_img_src2, .pcem_layout_2 .pc_em_model_img .pc_em_model_img_src2'
              )
              .delay(350)
              .animate(
                {
                  opacity: 1
                },
                600,
                'easeInOutQuad'
              );
            $('#pcem_look_2')
              .find(
                '.pcem_layout_1 .pc_em_swatch_img .pc_em_swatch_img_src:eq(0).back, .pcem_layout_2 .pc_em_swatch_img .pc_em_swatch_img_src.back:eq(0)'
              )
              .delay(400)
              .animate(
                {
                  opacity: 1
                },
                600,
                'easeInOutQuad'
              );
            $('#pcem_look_2')
              .find(
                '.pcem_layout_1 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0), .pcem_layout_2 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0)'
              )
              .delay(450)
              .animate(
                {
                  opacity: 1
                },
                560,
                'easeInOutQuad'
              );
            $('#pcem_look_2')
              .find('.pcem_layout_1 .pc_em_details_wrapper, .pcem_layout_2 .pc_em_details_wrapper')
              .delay(600)
              .animate(
                {
                  opacity: 1
                },
                800,
                'easeInOutQuad',
                function () {
                  lookTwoFirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        /* // Animation
                function lookThreeScene() {
                  if (lookThreeFirstRun) {

                    $('#pcem_look_3').find('.pcem_layout_3 .pc_em_model_img .pc_em_model_img_src:eq(0), .pcem_layout_2 .pc_em_model_img .pc_em_model_img_src:eq(0)').delay(350).animate({
                      opacity: 1
                    }, 600, 'easeInOutQuad');
                    $('#pcem_look_3').find('.pcem_layout_3 .pc_em_swatch_img .pc_em_swatch_img_src:eq(0), .pcem_layout_2 .pc_em_swatch_img .pc_em_swatch_img_src:eq(0)').delay(400).animate({
                      opacity: 1
                    }, 600, 'easeInOutQuad');
                    $('#pcem_look_3').find('.pcem_layout_3 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0), .pcem_layout_2 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0)').delay(450).animate({
                      opacity: 1
                    }, 560, 'easeInOutQuad');
                    $('#pcem_look_3').find('.pcem_layout_3 .pc_em_details_wrapper, .pcem_layout_2 .pc_em_details_wrapper').delay(600).animate({
                      opacity: 1
                    }, 800, 'easeInOutQuad', function () {
                      lookTwoFirstRun = false;
                    });
                  } else {
                    return;
                  }
                } */

        // Init scrollMagic Scene Class
        var lookTwoTimeline = new ScrollMagic.Scene({
          triggerElement: '#pcem_look_2 .pcem_layout_1, #pcem_look_2 .pcem_layout_2',
          offset: -100
        })
          .on('start', function () {
            lookTwoScene();
          })
          .addTo(controller);
        // Handle single play-through
        var lookThreeFirstRun = true;

        // Animation
        function lookThreeScene() {
          if (lookThreeFirstRun) {
            $('#pcem_look_3')
              .find(
                '.pcem_layout_3 .pc_em_model_img .pc_em_model_img_src3, .pcem_layout_2 .pc_em_model_img .pc_em_model_img_src3'
              )
              .delay(350)
              .animate(
                {
                  opacity: 1
                },
                600,
                'easeInOutQuad'
              );
            $('#pcem_look_3')
              .find(
                '.pcem_layout_3 .pc_em_swatch_img .pc_em_swatch_img_src.back:eq(0), .pcem_layout_2 .pc_em_swatch_img .pc_em_swatch_img_src.back:eq(0)'
              )
              .delay(400)
              .animate(
                {
                  opacity: 1
                },
                600,
                'easeInOutQuad'
              );
            $('#pcem_look_3')
              .find(
                '.pcem_layout_3 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0), .pcem_layout_2 .pc_em_lipsticks_img .pc_em_lipsticks_img_src:eq(0)'
              )
              .delay(450)
              .animate(
                {
                  opacity: 1
                },
                560,
                'easeInOutQuad'
              );
            $('#pcem_look_3')
              .find('.pcem_layout_3 .pc_em_details_wrapper, .pcem_layout_2 .pc_em_details_wrapper')
              .delay(600)
              .animate(
                {
                  opacity: 1
                },
                800,
                'easeInOutQuad',
                function () {
                  lookThreeFirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        // Init scrollMagic Scene Class
        var lookThreeTimeline = new ScrollMagic.Scene({
          triggerElement: '.pcem_layout_3',
          offset: -100
        })
          .on('start', function () {
            lookThreeScene();
          })
          .addTo(controller);
        // Handle single play-through
        var sceneOlapicFirstRun = true;

        // Animation
        function sceneOlapic() {
          if (sceneOlapicFirstRun) {
            $('.olapic-widget').animate(
              {
                opacity: 1,
                marginTop: '-4%'
              },
              600,
              'easeOutQuad',
              function () {
                sceneOlapicFirstRun = false;
              }
            );
          } else {
            return;
          }
        }

        // Init scrollMagic Scene Class
        var sceneTimelineOlapic = new ScrollMagic.Scene({
          triggerElement: '.olapic-widget',
          offset: -300
        })
          .on('start', function () {
            sceneOlapic();
          })
          .addTo(controller);
        /* Glows */
        var glowDuration = '250vw';
        var glowController = new ScrollMagic.Controller({
          globalSceneOptions: {
            duration: glowDuration
          }
        });

        function addGlow(glowID) {
          $(glowID).addClass('active');
        }

        // First glow
        new ScrollMagic.Scene({
          triggerElement: '.pcem_layout_1',
          offset: 60
        })
          .on('start', function () {
            addGlow('#pcem_look_glow_1');
          })
          .addTo(glowController);

        // Second glow
        new ScrollMagic.Scene({
          triggerElement: '.pcem_layout_2',
          offset: 60
        })
          .on('start', function () {
            addGlow('#pcem_look_glow_2');
          })
          .addTo(glowController);

        // Third glow
        new ScrollMagic.Scene({
          triggerElement: '.pcem_layout_3',
          offset: 60
        })
          .on('start', function () {
            addGlow('#pcem_look_glow_3');
          })
          .addTo(glowController);
      });
    }
  };
})(jQuery);
